<ds-promo-badge
  tone="green"
  iconSrc="/assets/icons/savings_green.svg"
  iconAlt="saving"
  label="Least Expensive"
/>
